// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Scrollable from "../../components/Scrollable.bs.js";
import * as FilterStore from "../store/FilterStore.bs.js";
import * as Row$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryContext from "../../data-source/country-config/context/CountryContext.bs.js";
import * as Column$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as Navbar$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/custom/navbar/Navbar.bs.js";
import * as CrmAssetsManager from "../../../root/crm/to-be-migrated/assets/CrmAssetsManager.bs.js";
import * as WorkSpaceContext from "../../work-space/WorkSpaceContext.bs.js";
import * as ViewUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ViewUtils.bs.js";
import * as CircularLoader$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as CrmControlledReleaseHOC from "../../data-source/controlled-rollout/component/CrmControlledReleaseHOC.bs.js";
import * as TableComponent$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as CrmControlledReleaseContext from "../../data-source/controlled-rollout/context/CrmControlledReleaseContext.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as FixedLoadingViewComponent$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/FixedLoadingViewComponent.bs.js";

CrmAssetsManager.importCss(undefined);

function T(Configration) {
  var FilterFunctor$T$FilterTab = function (Props) {
    var filterComp = Props.filterComp;
    return React.createElement("div", {
                className: "tabs__container"
              }, React.createElement("div", {
                    className: "simple-tab u-position-sticky single-tab"
                  }, "Filter"), React.createElement("div", {
                    className: "tab-content"
                  }, React.createElement("div", {
                        className: "filter-tab"
                      }, filterComp)));
  };
  var FilterTab = {
    make: FilterFunctor$T$FilterTab
  };
  var FilterFunctor$T = function (Props) {
    var params = Props.params;
    var match = CountryContext.useContext(undefined);
    var country = match.country;
    var initStateFromConfig = Curry._1(Configration.setInitState, params);
    var initialState_data = initStateFromConfig.data;
    var initialState_filter_request = initStateFromConfig.filter;
    var initialState = {
      data: initialState_data,
      filter_request: initialState_filter_request,
      offset: undefined,
      end_of_list: false,
      selected_filter: undefined,
      total_items: 0
    };
    var match$1 = React.useReducer(FilterStore.reducer, initialState);
    var dispatch = match$1[1];
    var state = match$1[0];
    var match$2 = React.useState(function () {
          
        });
    var showData = match$2[1];
    var visibleRowKey = match$2[0];
    var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
    var adminBetaPageAccessData = React.useContext(CrmControlledReleaseContext.context);
    var pageAccessType = CrmControlledReleaseHOC.getAccessType(adminBetaPageAccessData.adminBetaAccessData.page_config, "edit_order");
    React.useEffect((function () {
            Curry._5(Configration.loadData, state.filter_request, state.offset, dispatch, ViewUtils$Catalyst.extractLiveData(state.data), country);
            
          }), []);
    var onScrollEndCallback = function (param) {
      if (state.end_of_list) {
        return ;
      } else {
        return Curry._5(Configration.loadData, state.filter_request, state.offset, dispatch, ViewUtils$Catalyst.extractLiveData(state.data), country);
      }
    };
    var report = state.data;
    var tmp;
    switch (report.TAG | 0) {
      case /* Loading */0 :
          var report$1 = report._0;
          tmp = report$1 !== undefined ? React.createElement(Scrollable.make, {
                  height: "100%",
                  onScrollEndCallback: (function (param) {
                      
                    }),
                  children: null
                }, React.createElement(TableComponent$Catalyst.make, {
                      columns: Curry._4(Configration.tableConfig, workspaceDispatch, visibleRowKey, (function (key) {
                              return Curry._1(showData, (function (param) {
                                            return key;
                                          }));
                            }), pageAccessType),
                      rowData: report$1,
                      className: "filter-table",
                      is_sticky_header: true
                    }), React.createElement(FixedLoadingViewComponent$Catalyst.make, {})) : React.createElement(CircularLoader$Catalyst.make, {});
          break;
      case /* Live */1 :
          tmp = React.createElement(Scrollable.make, {
                height: "100%",
                onScrollEndCallback: onScrollEndCallback,
                children: React.createElement(TableComponent$Catalyst.make, {
                      columns: Curry._4(Configration.tableConfig, workspaceDispatch, visibleRowKey, (function (key) {
                              return Curry._1(showData, (function (param) {
                                            return key;
                                          }));
                            }), pageAccessType),
                      rowData: report._0,
                      className: "filter-table",
                      is_sticky_header: true
                    })
              });
          break;
      case /* Error */2 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: report._0
              });
          break;
      
    }
    return React.createElement(Column$Catalyst.make, {
                children: null,
                className: ""
              }, React.createElement(Navbar$Catalyst.make, {
                    title: Configration.pageTitle
                  }), React.createElement(Row$Catalyst.make, {
                    children: null,
                    className: "container"
                  }, React.createElement("div", {
                        className: "left-filter-section u-right-border"
                      }, React.createElement(FilterFunctor$T$FilterTab, {
                            filterComp: React.createElement(Configration.FilterForm.make, {
                                  filter: state.filter_request,
                                  applyFilter: (function (filter) {
                                      return Curry._5(Configration.loadData, filter, undefined, dispatch, ViewUtils$Catalyst.extractLiveData(state.data), country);
                                    }),
                                  total_items: state.total_items
                                })
                          })), React.createElement("div", {
                        className: "right-table-container"
                      }, tmp)));
  };
  return {
          FilterTab: FilterTab,
          make: FilterFunctor$T
        };
}

export {
  T ,
  
}
/*  Not a pure module */
